import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const overflowHiddenFn = /* @__PURE__ */ createRecipe('overflow-hidden', {}, [])

const overflowHiddenVariantMap = {}

const overflowHiddenVariantKeys = Object.keys(overflowHiddenVariantMap)

export const overflowHidden = /* @__PURE__ */ Object.assign(memo(overflowHiddenFn.recipeFn), {
  __recipe__: true,
  __name__: 'overflowHidden',
  __getCompoundVariantCss__: overflowHiddenFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: overflowHiddenVariantKeys,
  variantMap: overflowHiddenVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, overflowHiddenVariantKeys)
  },
  getVariantProps: overflowHiddenFn.getVariantProps,
})